module.exports = __webpack_public_path__ + "static/home_ch_luxe-83123135a6bcc0de5faf0874cec73612.jpg";